$(() => {
  const changeDisabled = () => {
    const email = $('#user_email').val();
    const password = $('#user_password').val();
    const password_confirmation = $('#user_password_confirmation').val();
    if (email || (password && password_confirmation)) {
      $('#js-submit').removeClass('disable');
      return $('#js-submit>input').prop('disabled', false);
    } else {
      $('#js-submit').addClass('disable');
      return $('#js-submit>input').prop('disabled', true);
    }
  };

  $('#user_email,#user_password,#user_password_confirmation').on('input', () => {
    return changeDisabled();
  });

  return changeDisabled();
});
